




import { defineComponent } from "@vue/composition-api";
import { IS_BROWSER } from "@/lib/browserUtils";

export default defineComponent({
  name: "PageLoginTwitter",
  props: {
    queryString: { type: Object as () => { oauth_token?: string; oauth_verifier?: string }, required: true },
  },
  mounted() {
    const url = this.queryString;
    if (IS_BROWSER) {
      if (url["oauth_token"] && url["oauth_verifier"]) {
        (window.opener as typeof window).TWTRAuthHandler?.({
          requestToken: url["oauth_token"] || "",
          verifier: url["oauth_verifier"] || "",
        });
      } else (window.opener as any).TWTRAuthHandler(null);
      window.close();
    }
  },
});
